import ApiStore from 'shared/stores/ApiStore';

export default class CountryStore extends ApiStore {
    __countries = [{'code':'WWW', 'ab':'ALL', 'short_name':'Страна', 'name': 'Страна происхождения'}]

    constructor() {
        super(...arguments);
        this.configure({
          domain: process.env.REACT_APP_API_DOMAIN,
          prefix: process.env.REACT_APP_API_PREFIX
        });
      }

    get isLoadCountries(){
        return Object.keys(this.countries).length > 1;
    }

    get countries(){
        return this.__countries;
    }
    set countries(value){
        this.__countries = value;
    }

    async fetchCountries() {
        const type = 'tnved/countries'
        const query = {}
        const url = this.buildUrl(type, { query }).slice(0,-1);
        const items = await this.request(url);
        items.forEach(item => this.countries.push(item) )
        return this.countries; 
    }

    async reload() {
        return await this.fetchCountries();
    }
}



// WEBPACK FOOTER //
// ./src/stores/CountryStore.js